export default __webpack_public_path__ + "static/media/arrow l.51945d27.svg";